// extracted by mini-css-extract-plugin
export var compact = "yHwLo";
export var full = "cM5XH";
export var medium = "Rkr4S";
export var monarchFavoriteList = "Gi26J";
export var nodeHeight = "n6d0i";